import { createBrowserHistory } from "history";

/**
 * explicitly defined history object that can be modified outside react components.
 */
export default createBrowserHistory();
